import Vue from 'vue';

const state = {
  notifications: {}
}

const getters = {

  notification (state) {
    return id => {
      if (id in state.notifications) return state.notifications[id];
      else return false;
    }
  },

  notifications (state) {
    return state.notifications;
  }
}

const mutations = {

  storeNotifications (state, notifications) {
    notifications.forEach(notification => {
      var current = state.notifications[notification._id] || {};
      Vue.set(state.notifications, notification._id, {
        ...current,
        ...notification
      });
    });
  },

  clearNotifications () {
    Vue.set(state, 'notifications', {});
  }
}

const actions = {
  
  loadNotifications ({commit}, params) {

    var filters = params.filters || {};

    var queryParams = {
      ...filters,
    };

    return window.server.getReq('/notifications', {
      params: queryParams
    })
    .then(data => {
      commit('storeNotifications', data);
      return Promise.resolve(data);
    })
    .catch(e => {
      console.log('state - notifications - actions.loadNotifications Error:', e);
      return Promise.reject(e);
    });
  },

  notificationToggleRead ({commit, dispatch}, params) {

    if (!params.notification || !params.notification._id) {
      return Promise.reject('state - toggle Notifications Read - missing required param "notification" ');
    }

    var read = params.notification.reads[0].hasRead > 0 ? 'unread' : 'read';

    return window.server.putReq('/notification/' + params.notification._id + '/mark/' + read)
    .then(data => {
      params.notification.reads[0].hasRead = params.notification.reads[0].hasRead > 0 ? 0 : Date.now();
      commit('storeNotifications', [params.notification]);
      return Promise.resolve(data);
    })
    .catch(e => {
      console.log('state - notifications - actions.loadNotifications Error:', e);
      return Promise.reject(e);
    });
  }
  
};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/notification.js